import { ApiClient, TokenAdd } from "@/services/apiClient";
import { type Category, CategoryId } from "@/services/collection/categories/types";

// Load them only once during session
let cache_all: Promise<Category[]> | undefined = undefined;
let cache_havingArticle: Promise<Category[]> | undefined = undefined;

export const fetchAll = async (): Promise<Category[]> => {
  if (cache_all === undefined) {
    const url = "api-public/collection/category";
    cache_all = ApiClient.getPublic<Category[]>(url, {}, TokenAdd.Never).then(({ data }) => data);
  }

  return cache_all;
};

/** @deprecated Use fetchCategoryByUrl() for better readability. */
export const fetchByUrl = async (slug: string): Promise<Category | undefined> => fetchCategoryByUrl(slug);

/** @deprecated Use fetchCategoryById() for better readability. */
export const fetchById = async (id: CategoryId): Promise<Category> => fetchCategoryById(id);

export const fetchCategoryById = async (id: CategoryId): Promise<Category> =>
  fetchAll().then((categories) => {
    const category = categories.find((category) => category.id === id);
    if (category === undefined) {
      throw new Error("Category not found: " + id);
    } else {
      return category;
    }
  });

export const fetchCategoryByUrl = async (slug: string): Promise<Category | undefined> => fetchAll().then((categories) => categories.find((category) => category.url === slug));

export const fetchMyTopUsed = async (): Promise<Category[]> => {
  const url = "api/collection/category/my-top-used";
  return ApiClient.get<Category[]>(url).then(({ data }) => data);
};

export const fetchHavingArticle = async (): Promise<Category[]> => {
  if (cache_havingArticle === undefined) {
    const url = "collection/categories/get-having-articles";
    cache_havingArticle = ApiClient.getPublic<Category[]>(url).then(({ data }) => data);
  }

  return cache_havingArticle;
};
